function SmallSkill({logo, name, animationDelay, onLoad})
{
    return <div className="smallSkill" style={{animationDelay: `${animationDelay}ms`}}>
        <img src={`/media/images/logos/${logo}`} alt={name} onLoad={onLoad}/>
        <h3>{name}</h3>
    </div>
}

export default SmallSkill;